import { getApp } from 'firebase/app';
import { getStripePayments } from '@stripe/firestore-stripe-payments';

export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51QQXYeLBBFx4ftHYAF1otwTIsW7BUYTfdPHiOnr1iKpAF0PCUKR6ihQQi5F7rqREZuC3E7KpOb1n58iqZSchvr2s00iYkfIuxe';

export const HOLIDAY_CHEER_PRICE = {
  priceId: 'price_1QSEszLBBFx4ftHYXpXmHWGV',
  amount: 1500,
  currency: 'usd'
};

export const STRIPE_CONFIG = {
  productsCollection: 'products',
  customersCollection: 'customers',
  successUrl: '/dashboard',
  cancelUrl: '/packages'
};

export const payments = getStripePayments(getApp(), {
  productsCollection: STRIPE_CONFIG.productsCollection,
  customersCollection: STRIPE_CONFIG.customersCollection,
  stripePublishableKey: STRIPE_PUBLISHABLE_KEY,
});